"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodSelect = PaymentMethodSelect;
exports.PaymentMethodOption = PaymentMethodOption;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/PaymentMethodSelect/index.tsx
// Figma: SelectPaymentMethod — 支払い方法のラジオ選択カード。
//
// PaymentMethodSelect — ガラス面コンテナ (PropertyBlock)
// PaymentMethodOption — 1 行。[Radio][タイトル + 補足 + 説明][任意アクション]
//                       選択時に展開する入力欄などは children に渡す。
//
// 行全体が押下領域なので、action (「登録」ボタン) は button の入れ子を
// 避けるため行の押下領域の外に置き、クリックの伝播を止める。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var PropertyBlock_1 = require("../PropertyBlock");
var SelectionControls_1 = require("../SelectionControls");
function PaymentMethodSelect(_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)(PropertyBlock_1.PropertyBlock, { children: children });
}
function PaymentMethodOption(_a) {
    var selected = _a.selected, onSelect = _a.onSelect, title = _a.title, titleSuffix = _a.titleSuffix, description = _a.description, _b = _a.descriptionTone, descriptionTone = _b === void 0 ? 'secondary' : _b, notes = _a.notes, action = _a.action, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isLast, isLast = _d === void 0 ? false : _d;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
            borderBottom: isLast ? 'none' : "1px solid ".concat(p.border.neutral.default),
        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "flex-start", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: {
                    boxSizing: 'border-box',
                    width: '100%',
                    p: "".concat(tokens_1.spacing.md, "px"),
                }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { component: material_1.ButtonBase, direction: "row", alignItems: "flex-start", spacing: "".concat(tokens_1.spacing.xs, "px"), role: "radio", "aria-checked": selected, "aria-disabled": disabled, disabled: disabled, onClick: function (event) {
                            return !disabled && onSelect(event);
                        }, sx: {
                            flex: '1 1 0%',
                            minWidth: 0,
                            textAlign: 'left',
                            justifyContent: 'flex-start',
                            cursor: disabled ? 'default' : 'pointer',
                        }, children: [(0, jsx_runtime_1.jsx)(SelectionControls_1.RadioMark, { checked: selected, disabled: disabled }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.xs, "px"), sx: { flex: '1 1 0%', minWidth: 0 }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: { minWidth: 0 }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.subsectionTitle), { lineHeight: "".concat(tokens_1.lineHeight.md, "px"), color: disabled
                                                        ? p.foreground.neutral.disabled
                                                        : p.foreground.neutral.primary }), children: title }), titleSuffix && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({ flex: '1 1 0%', minWidth: 0 }, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: disabled
                                                        ? p.foreground.neutral.disabled
                                                        : p.foreground.neutral.primary }), children: titleSuffix }))] }), description && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.caption), { lineHeight: "".concat(tokens_1.lineHeight.xs, "px"), color: disabled
                                                ? p.foreground.neutral.disabled
                                                : descriptionTone === 'primary'
                                                    ? p.foreground.neutral.primary
                                                    : p.foreground.neutral.secondary }), children: description })), notes && ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.caption), { lineHeight: "".concat(tokens_1.lineHeight.xs, "px"), color: disabled
                                                ? p.foreground.neutral.disabled
                                                : p.foreground.neutral.secondary, whiteSpace: 'pre-wrap' }), children: notes }))] })] }), action && (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { flexShrink: 0 }, children: action })] }), children && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    pl: "".concat(tokens_1.spacing.md + RADIO_COLUMN_WIDTH + tokens_1.spacing.xs, "px"),
                    pr: "".concat(tokens_1.spacing.md, "px"),
                    pb: "".concat(tokens_1.spacing.md, "px"),
                }, children: children }))] }));
}
/** RadioMark の外形幅 (円 20px + 上下左右 4px パディング) */
var RADIO_COLUMN_WIDTH = 28;
